import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=3b0065b8&scoped=true"
import script from "./menu.vue?vue&type=script&lang=ts"
export * from "./menu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0065b8",
  null
  
)

export default component.exports